var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full bg-white text-gray-500 text-sm transition",class:{'border-2 border-gray-300 border-dotted' : _vm.zoom != 1},style:(_vm.cameraPosition)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }